import {
  GO_TO_NEXT_MODAL,
  GO_TO_PREVIOUS_MODAL,
  NBS_WS_AUTH_DONE_RECEIVED,
  DELETE_ALL_ACTIONS_REQUIRED,
  DELETE_MODAL,
} from '../../constants/actions';
import {
  mapAllActions,
  getPrimaryActions,
  getSecondaryActions,
  getTotalCountOfSteps,
} from '../../assets/helpers/missingRejectedModalHelper';
import { isEmpty } from '../../assets/helpers/utils';

const initialState = {
  actions: [],
  currentModal: null,
  actionsList: [],
  primaryActionsArr: [],
  secondaryActionsArr: [],
  actionIndex: 0,
  primaryActionsCompleted: false,
  secondaryActionsCompleted: false,
  onboardingSteps: 0,
};

export default function reducer(state = initialState, action = {}) {
  let {
    actions,
    currentModal,
    actionIndex,
    actionsList,
    primaryActionsArr,
    secondaryActionsArr,
    primaryActionsCompleted,
    secondaryActionsCompleted,
    onboardingSteps,
  } = state;

  switch (action.type) {
    case NBS_WS_AUTH_DONE_RECEIVED:
      const { actions_required } = action.data;
      actions = [...actions_required];
      primaryActionsArr = getPrimaryActions(actions);
      secondaryActionsArr = getSecondaryActions(actions);
      actionsList = [...primaryActionsArr, ...secondaryActionsArr];

      if (!isEmpty(primaryActionsArr)) {
        primaryActionsCompleted = false;
      } else {
        primaryActionsCompleted = true;
      }

      if (!isEmpty(secondaryActionsArr)) {
        secondaryActionsCompleted = false;
      } else {
        secondaryActionsCompleted = true;
      }

      if (actionsList[0]) {
        currentModal = actionsList[0].action;
      }

      onboardingSteps = getTotalCountOfSteps(actionsList);

      return {
        ...state,
        actions,
        currentModal,
        primaryActionsArr,
        secondaryActionsArr,
        actionsList,
        primaryActionsCompleted,
        secondaryActionsCompleted,
        onboardingSteps,
      };
    case GO_TO_NEXT_MODAL:
      actionIndex++;
      if (actionsList[actionIndex]) {
        currentModal = actionsList[actionIndex].action;

        if (
          !primaryActionsCompleted &&
          actionsList[actionIndex].type === 'secondary'
        ) {
          primaryActionsCompleted = true;
        }
      } else {
        secondaryActionsCompleted = true;
        primaryActionsCompleted = true;
        currentModal = null;
        actionIndex = 0;
      }

      return {
        ...state,
        actionIndex,
        currentModal,
        primaryActionsCompleted,
        secondaryActionsCompleted,
      };
    case GO_TO_PREVIOUS_MODAL:
      actionIndex--;
      if (actionsList[actionIndex]) {
        currentModal = actionsList[actionIndex].action;
      } else {
        currentModal = null;
        actionIndex = 0;
      }

      return { ...state, actionIndex, currentModal };
    case DELETE_ALL_ACTIONS_REQUIRED:
      return { ...initialState };
    case DELETE_MODAL:
      const idx = actionsList.findIndex((a) => a.action === action.modal);

      if (idx) {
        actionsList.splice(idx, 1);
      }

      return { ...state, actionsList };
    default:
      return state;
  }
}
